import { render, staticRenderFns } from "./AdminConfigurePipelineDataStreamsPage.vue?vue&type=template&id=8731ce54"
import script from "./AdminConfigurePipelineDataStreamsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminConfigurePipelineDataStreamsPage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports